<template>
    <div class="weui-msg">
      <div class="weui-msg__icon-area">
        <img class="gif-img" src="./img/loading.gif"/>
      </div>
      <div class="weui-msg__text-area">
          <h2 class="weui-msg__title">正在出货，请耐心等待...</h2>
          <p class="weui-msg__desc">出货过程中请您切勿走开，网络信号传输会有些许的延迟，请您耐心等待。</p>
      </div>
      <div class="weui-msg__opr-area">
          <p class="weui-btn-area">
              <!-- <a href="javascript:;" class="weui-btn weui-btn_primary" @click="handleClick">关闭页面</a> -->
<!--                   <a href="javascript:;" class="weui-btn weui-btn_default">辅助操作</a> -->
          </p>
      </div>
      <div class="weui-msg__extra-area">

      </div>
  </div>
</template>

<script>
export default {
  name: 'goodsPushPage',
  data () {
    return {
       goods:[]

    }
 },
 computed: {

 },
  methods: {
    handleClick:function(){
      this.$emit('confirm')
    }
  }
}
</script>


<style scoped>

.gif-img{
  width:50%;
}

.weui-msg{
  padding-top:36px;
  text-align:center;
}
.weui-msg__icon-area{
  width:100%;
  margin-bottom:30px;
}
.weui-msg__text-area{
  margin-bottom:25px;
  padding:0 20px;
}
.weui-msg__text-area a{
  color:#586C94;
}
.weui-msg__title{
  margin-bottom:5px;
  font-weight:400;
  font-size:20px;
  word-wrap:break-word;
  word-break:break-all;
}
.weui-msg__desc{
  font-size:14px;
  color:#999999;
  word-wrap:break-word;
  word-break:break-all;
}
.weui-msg__opr-area{
  margin-bottom:25px;
}
.weui-msg__extra-area{
  margin-bottom:15px;
  font-size:14px;
  color:#999999;
}
.weui-msg__extra-area a{
  color:#586C94;
}
@media screen and (min-height: 438px){
  .weui-msg__extra-area{
    position:fixed;
    left:0;
    bottom:0;
    width:100%;
    text-align:center;
  }
}
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3){
  .weui-msg__extra-area{
    margin-bottom:49px;
  }
}
</style>    


// WEBPACK FOOTER //
// src/components/goodsPushPage/goodsPushPage.vue